<form>
  <div class="row">
    <div class="col-md-12 col-xl-12">
      <div class="table-responsive our-table">
        <table class="table table-striped text-nowrap mb-0">
          <thead class="border-top">
            <tr>
              <th class="text-capitalize">{{ "common.type" | translate }}</th>
              <th class="text-capitalize">{{ "common.origin" | translate }}</th>
              <th class="text-capitalize">
                {{ "common.application" | translate }}
              </th>
              <th class="text-capitalize">
                {{ "common.requestedValue" | translate }}
              </th>
              <th class="text-capitalize">{{ "common.fees" | translate }}</th>
              <th class="text-capitalize">{{ nameColumn }}</th>
              <th class="text-capitalize">
                {{ "common.amountMoved" | translate }}
              </th>
              <th class="text-capitalize">
                {{ "common.transactionCount" | translate }}
              </th>
            </tr>
          </thead>

          <tbody>
            <ng-container
              *ngFor="let row of transactionWithdrawDeposit; let i = index"
            >
              <tr
                *ngIf="
                  i > 0 &&
                  row.type === 'SAQUE' &&
                  transactionWithdrawDeposit[i - 1].type === 'DEPOSITO'
                "
              >
                <td colspan="9" class="p-2 border-bottom"></td>
              </tr>

              <tr class="border-bottom border-top">
                <td>
                  <span>{{ row.type }}</span>
                </td>
                <td>
                  <span>{{ row.origin || "-" }}</span>
                </td>
                <td>
                  <span>{{ mapApplication(row.application) }}</span>
                </td>
                <td>
                  <span>{{ row.requestedValue | formatCurrency }}</span>
                </td>
                <td>
                  <span>{{ row.taxValue | formatCurrency }}</span>
                </td>
                <td>
                  <span>{{ row.split | formatCurrency }}</span>
                </td>
                <td>
                  <span>{{ row.movedValue | formatCurrency }}</span>
                </td>
                <td>
                  <span>{{ row.qtde | number: "1.0-0" }}</span>
                </td>
                <td><span></span></td>
              </tr>
            </ng-container>

            <tr *ngIf="transactionWithdrawDeposit?.length">
              <td colspan="9" class="p-2 border-bottom"></td>
            </tr>

            <tr *ngIf="!transactionWithdrawDeposit?.length">
              <td colspan="9">{{ "common.noData" | translate }}</td>
            </tr>
          </tbody>
          <tfoot *ngIf="transactionWithdrawDeposit?.length">
            <tr class="fw-bold">
              <td colspan="2" class="text-start fw-bold">
                {{ "common.depositTotal" | translate }}
              </td>
              <td></td>
              <td class="fw-bold">{{ totalDepRequested | formatCurrency }}</td>
              <td class="fw-bold">{{ totalDepTax | formatCurrency }}</td>
              <td class="fw-bold">{{ totalDepSplit | formatCurrency }}</td>
              <td class="fw-bold">{{ totalDepMoved | formatCurrency }}</td>
              <td class="fw-bold">{{ totalDepCount | number: "1.0-0" }}</td>
              <td></td>
            </tr>

            <tr>
              <td colspan="2" class="text-start fw-bold">
                {{ "common.withdrawalTotal" | translate }}
              </td>
              <td></td>
              <td class="fw-bold">{{ totalSaqRequested | formatCurrency }}</td>
              <td class="fw-bold">{{ totalSaqTax | formatCurrency }}</td>
              <td class="fw-bold">{{ totalSaqSplit | formatCurrency }}</td>
              <td class="fw-bold">{{ totalSaqMoved | formatCurrency }}</td>
              <td class="fw-bold">{{ totalSaqCount | number: "1.0-0" }}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</form>
